import React from "react"
import { func, node, string } from "prop-types"
import { QueryErrorResetBoundary } from "@tanstack/react-query"
import FetchErrorScreen from "./FetchErrorScreen"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidUpdate(prevProps) {
    // Reset on navigation so a failure on the route being left does not follow
    // the user to the next one. Only reachable where the boundary sits inside
    // the layout and the nav chrome survives to be clicked. Mirrors
    // RouteErrorBoundary.
    if (this.state.hasError && prevProps.locationKey !== this.props.locationKey) {
      this.props.onReset()
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <FetchErrorScreen
          message="Failed to retrieve data from the server."
          onRetry={() => {
            this.props.onReset()
            this.setState({ hasError: false })
          }}
        />
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  onReset: func.isRequired,
  locationKey: string,
  children: node.isRequired,
}

function QueryErrorBoundary({ children, locationKey }) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary onReset={reset} locationKey={locationKey}>
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}

QueryErrorBoundary.propTypes = {
  children: node.isRequired,
  locationKey: string,
}

export default QueryErrorBoundary
